export default {
  center: {
    textAlign: 'center'
  },
  date: {
    width: '80px'
  }
}
